export default __webpack_public_path__ + "static/media/joinus_img_01_process.ce50f1c8.svg";